import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { IUser } from 'src/app/core/models/user.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { LogoService } from 'src/app/core/services/logo.service';

@Component({
  selector: 'app-logos-list',
  templateUrl: './logos-list.component.html',
  styleUrls: ['./logos-list.component.css'],
})
export class LogosListComponent implements OnInit {
  @Input() darkMode: boolean;
  @Input() role: string;
  @Input() userId: string;
  @Input() clientId: string;
  @Input() customerId: string;
  @Output() reloadLogos = new EventEmitter();

  urlParams: string;

  addedLogos: any;
  availablelogos: any;

  allLogos: any;

  searchParam: string;
  logosSearch: any;
  searchParamAll: string;
  logosSearchAll: any;
  showMyContainer = false;

  selectedLogo: any = 'Select logos...';

  logoToDelete: any;

  logos: any;
  logo: any;
  changeFile = false;
  logoName: string = '';
  previewFile = null;

  logoModal: any;
  addLogoModal: any;

  toggleAddLogo = false;

  isUploading = false;
  uploading = false;

  page = 1;
  perPage = 16;

  currentUser: IUser;
  fileToUpload: any;

  private dialogOptions: NgbModalOptions = {
    backdropClass: 'dark-backdrop',
    centered: true,
    windowClass: 'window-modal',
  };

  constructor(
    private logoService: LogoService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    public router: Router,
    public route: ActivatedRoute,
    private authService: AuthService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.translate.get(['global.selectLogo']).subscribe((values) => {
      this.selectedLogo = values['global.selectLogo'];
    });
    this.authService.LoggedinUser.subscribe((user) => {
      this.currentUser = user;
    });
    this.route.queryParams.subscribe((queryParams: any) => {
      this.urlParams = queryParams;
    });

    this.loadLogos();
  }

  loadLogos() {
    let getlogo$ = new Observable();
    let getAvailableLogos$ = new Observable();

    switch (this.role) {
      case 'root':
        getlogo$ = this.logoService.getLogos();
        break;
      case 'customer':
        if (this.currentUser.role.name === 'root') {
          getlogo$ = this.logoService.getCustomerLogos(this.customerId);
          getAvailableLogos$ = this.logoService.getLogos();
        } else {
          getlogo$ = this.logoService.getCustomerLogos(this.customerId);
          getAvailableLogos$ = this.logoService.getCustomerLogos(
            this.currentUser.customerId
          );
        }
        break;
      case 'client':
        getlogo$ = this.logoService.getClientLogos(this.clientId);
        getAvailableLogos$ = this.logoService.getCustomerLogos(this.customerId);
        break;
      case 'user':
        getlogo$ = this.logoService.getUserLogos(this.userId);
        getAvailableLogos$ = this.logoService.getClientLogos(this.clientId);
        break;
      default:
        break;
    }

    getlogo$.subscribe((logos) => {
      this.addedLogos = logos;
      this.logosSearchAll = logos;
    });

    if (getAvailableLogos$) {
      getAvailableLogos$.subscribe((logos) => {
        this.availablelogos = logos;
      });
    }
  }

  openAddLogoModal(content) {
    this.logo = null;
    this.logoName = '';
    this.fileToUpload = null;
    this.changeFile = false;

    this.addLogoModal = this.modalService.open(content, this.dialogOptions);
    this.addLogoModal.result.then(
      (result) => {},
      (reason) => {
        this.previewFile = null;
      }
    );
  }

  fileSelectorOpen() {
    const element: HTMLElement = document.getElementById(
      `image`
    ) as HTMLElement;

    element.click();
  }

  getFiles(event) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.fileToUpload = input.files[0];
      this.readURL(this.fileToUpload);
    }
  }

  isLoading: boolean = false;
  uploadLogo() {
    if (!this.logo) {
      if (this.fileToUpload === null) {
        return this.translate.get('errors.pleaseUploadFile').subscribe((text: string) => {
          this.toastr.error(text);
        });
      }

      const formData: FormData = new FormData();
      formData.append('logoFile', this.fileToUpload);
      this.logoName && formData.append('name', this.logoName);

      this.isUploading = true;
      this.isLoading = true;

      let createLogo$ = new Observable();

      switch (this.role) {
        case 'root':
          createLogo$ = this.logoService.addLogo(formData);
          break;
        case 'customer':
          createLogo$ = this.logoService.addLogoToCustomer(
            this.customerId,
            formData
          );
          break;
        default:
          break;
      }
      createLogo$.subscribe(
        (res) => {
          this.toggleAddLogo = false;
          this.isUploading = false;
          this.isLoading = false;
          this.toastr.success('Logo added');
          this.loadLogos();
          this.reloadLogos.emit();
          this.addLogoModal.close();
        },
        (error) => {
          this.isLoading = false;
          this.isUploading = false;
          this.toastr.error(error.message);
        }
      );
    } else {
      if (!this.logoName) {
        return this.translate.get('errors.youMustEnterName').subscribe((text: string) => {
          this.toastr.error(text);
        });
      }

      const formData: FormData = new FormData();
      this.fileToUpload && formData.append('logoFile', this.fileToUpload);
      formData.append('name', this.logoName);

      this.isLoading = true;

      this.logoService.updateLogo(formData, this.logo.id)
        .subscribe(
          response => {
            console.log('Logo updated successfully:', response);
            this.isUploading = false;
            this.addLogoModal.close();
            this.previewFile = null;

            this.logo.path = response.path;
            this.logo.thumbnailPath = response.thumbnailPath;
            this.logo.filename = response.filename;
          },
          error => {
            console.error('Error updating logo:', error);
            this.isUploading = false;
          }
        );
    }
  }

  assignLogo(logoId: string) {
    const isAssigned = this.addedLogos?.some((plate) => plate.id === logoId);

    if (isAssigned) {
      this.translate.get('errors.logoIsAlreadyAdded').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return false;
    }

    let addLogo$ = new Observable();

    switch (this.role) {
      case 'customer':
        addLogo$ = this.logoService.addLogoToCustomer(this.customerId, {
          logoId,
        });
        break;
      case 'client':
        addLogo$ = this.logoService.addLogoToClient(this.clientId, {
          logoId,
        });
        break;
      case 'user':
        addLogo$ = this.logoService.addLogoToUser(this.userId, {
          logoId,
        });
        break;
      default:
        break;
    }

    addLogo$.subscribe((res) => {
      this.loadLogos();
      this.reloadLogos.emit();
      this.showMyContainer = !this.showMyContainer;
      this.toastr.success('Successfully added logo.');
    });
  }

  openLogoModal(content, logo: any) {
    this.logoToDelete = logo;
    this.logoModal = this.modalService.open(content, this.dialogOptions);
  }

  deleteLogo(logo) {
    let deleteLogo$ = new Observable();

    switch (this.role) {
      case 'root':
        deleteLogo$ = this.logoService.deleteLogo(logo.id);
        break;
      case 'customer':
        deleteLogo$ = this.logoService.deleteLogoFromCustomer(
          this.customerId,
          logo.id
        );
        break;
      case 'client':
        deleteLogo$ = this.logoService.deleteLogoFromClient(
          this.clientId,
          logo.id
        );
        break;
      case 'user':
        deleteLogo$ = this.logoService.deleteLogoFromUser(this.userId, logo.id);
        break;
      default:
        break;
    }

    deleteLogo$.subscribe(
      (res) => {
        this.toastr.success('Logo deleted.');
        this.loadLogos();
        this.reloadLogos.emit();
        this.logoModal.close();
        this.previewFile = null;
      },
      (err) => {}
    );
  }

  jumpToPage(event: any) {
    this.page = event;
  }

  openDropdown() {
    this.showMyContainer = !this.showMyContainer;
    this.searchParam = '';
    this.logosSearch = this.availablelogos;
  }

  applyFilter() {
    this.logosSearch = this.availablelogos.filter((logo) =>
      logo.filename.toLowerCase().includes(this.searchParam.toLowerCase())
    );
  }

  applyFilterAddedLogos() {
    this.page = 1;
    this.logosSearchAll = this.addedLogos.filter((logo) =>
      logo.filename.toLowerCase().includes(this.searchParamAll.toLowerCase())
    );
  }

  clearSearch() {
    if (this.searchParamAll !== '') {
      this.searchParamAll = '';
      this.applyFilterAddedLogos();
    }
  }

  editLogo(content, logo) {
    this.logo = logo;
    this.logoName = logo.filename;
    this.fileToUpload = null; // Reset the file input
    this.changeFile = false; // Reset change file option

    this.addLogoModal = this.modalService.open(content, this.dialogOptions);
    this.addLogoModal.result.then(
      (result) => {},
      (reason) => {
        this.logo = null;
        this.previewFile = null;
      }
    );
  }

  readURL(image) {
    const reader = new FileReader();

    reader.addEventListener(
      'load',
      () => {
        this.previewFile = reader.result;
      },
      false
    );

    if (image) {
      reader.readAsDataURL(image);
    }
  }
}
